import { isNullOrUndefined } from 'common/functions/comparison';

import { Observable, BehaviorSubject } from 'common/barrels/rx';
import { Binding, ValueBinding, canWrite, canReadWrite, canReadOnly, canObserve } from 'common/dom/binding';
import { div, span } from 'common/barrels/dom';
import { numberbox } from 'common/barrels/controls';
import { Substream } from 'common/substream';

import 'common/styles/controls/duration.less';

export type duration = {
    seconds?: number,
    minutes?: number,
    hours?: number,
    days?: number,
    weeks?: number,
    months?: number,
    years?: number
};

export function duration(
    value: Binding<duration>,
    displayedUnits: ValueBinding<Array<keyof duration>> = null,
    isEditable: Observable<boolean> = null,
): JQuery {
    const $element = div('studio-duration');

    const editable = value == null || !canWrite(value) ? Observable.of(false)
        : isEditable == null ? Observable.of(true)
        : isEditable;

    new DurationPicker($element, value, displayedUnits, editable);

    return $element;
}

class DurationPicker {
    private duration: BehaviorSubject<duration>;
    constructor(
        public $element: JQuery,
        value: Binding<duration>,
        displayedUnits: ValueBinding<Array<keyof duration>>,
        editable: Observable<boolean>
    ) {
        const initialValue = canReadOnly(value) ? value
            : canReadWrite(value) ? value.getValue()
            : this.defaultDuration

        this.duration = canReadWrite(value) ? value : new BehaviorSubject(initialValue);

        const unitInputs = (displayedUnits: Array<keyof duration>) => {
            return Object.keys(this.defaultDuration)
                .filter(key => !isNullOrUndefined(initialValue[key]) && displayedUnits.some(d => d === key))
                .map(key => {
                    const label = key.substr(0, 1).toUpperCase() + key.substr(1) + ':';

                    const unit = new Substream<duration, number>(this.duration, x => x[key], (x, y) => {
                        const duration = Object.assign({}, x);
                        return duration[key] = y, duration;
                    });

                    const $input = numberbox(unit);

                    return div()
                        .append(span().text(label))
                        .append($input)
                        .owns(editable.subscribe(ie => $input.prop('disabled', !ie)));
                });
        }

        const $inputs = div('.studio-duration-units');

        $element.append(canWrite(displayedUnits) ? $inputs.bindPartialContent(displayedUnits, x => unitInputs(x)) : $inputs.append(unitInputs(displayedUnits)));

        if (canObserve(value) && !canWrite(value)) {
            $element.owns(value.subscribe(d => this.duration.next(d)));
        }
    }

    private readonly defaultDuration : duration = {
        years: 0,
        months: 0,
        weeks: 0,
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
    };
}